module.exports = "https://cdn.realtymogul.com/static/media/img_hero_whyCRE.e990a2e2.jpg";